  <kendo-dialog
    title="Renseigner une absence"
    (close)="closePop()"
    [minWidth]="250"
    [width]="800"
    [draggable]="isDraggable"
  >
  <div class="uk-child-width-1-4" uk-grid>
      <label>
        <input
          type="checkbox"
          class="checkbox"
          checked="coche"
          [(ngModel)]="checkAbsence"
          (click)="checkAll('checkAbsence')"
        />
        <span> Absence</span>
        <!-- Remplacer la case par : "Absence : {{motif}}-->
      </label>
      <div class="switch" class="uk-width-3-4">
        <label> Absence sur toute la session </label>
        <kendo-switch [checked]="absenceAllSession" (valueChange)="changeAbsenceAllSession($event)"></kendo-switch>
        <!-- Remplacer toutes les cases de l'apprenant par : "Absence : {{motif}}-->
      </div>    
      <label>
        <input type="checkbox" class="checkbox" [(ngModel)]="checkRetard" (click)="checkAll('checkRetard')" />
        <span> Retard</span>
        <!-- Garder la case coché mais mettre en dessous "Arriver à {{heure}}, motif : {{motif}}-->
      </label>
      <div>
        <kendo-timepicker [format]="'HH:mm'" [(value)]="heureRetardValue">
          <kendo-timepicker-messages
            now="Maintenant"
            cancel="Annuler"
            accept="Valider"
            cancelLabel="Annuler la saisie"
            acceptLabel="Valider cet horaire"
            nowLabel="Choisir l'heure actuelle"
            toggle="Afficher la liste"
          ></kendo-timepicker-messages>
        </kendo-timepicker>
      </div>
      <label>
        <input
          type="checkbox"
          class="checkbox"
          [(ngModel)]="checkDepart"
          (click)="checkAll('checkDepart')"
        />
        <span> Départ anticipé</span>
      </label>
      <div>
        <kendo-timepicker [format]="'HH:mm'" [(value)]="heureDepartAnticipeValue">
          <kendo-timepicker-messages
            now="Maintenant"
            cancel="Annuler"
            accept="Valider"
            cancelLabel="Annuler la saisie"
            acceptLabel="Valider cet horaire"
            nowLabel="Choisir l'heure actuelle"
            toggle="Afficher la liste"
          ></kendo-timepicker-messages>
        </kendo-timepicker>
      </div>
      <label class="uk-width-1-4 label-height">Motif</label>
      <div class="uk-width-3-4">
        <select [(ngModel)]="motifAbsentId" class="uk-select">
          <option *ngFor="let item of listMotifAbsence" [value]="item.id">{{ item.libelle }}</option>
        </select>
      </div>
    
    <div *ngIf="errorparams" [@alertDisplay]="" class="invalid-feedback-value k-text-center font-size-100 uk-width-4-4" role="alert">
      <strong>Veuillez</strong> sélectionner soit une absence, un retard ou un départ anticipé.
    </div>
    <div
      *ngIf="!motifAbsentId && (checkAbsence || absenceAllSession)"
      [@alertDisplay]=""
      class="invalid-feedback-value k-text-center font-size-100"
      role="alert"
    >
      Veuillez choisir un motif d'absence
    </div>
    <div *ngIf="errorServer" [@alertDisplay]="" class="invalid-feedback-value k-text-center font-size-100 uk-width-4-4" role="alert">
      <strong>Impossible</strong> de modifier l'information, veuillez réessayer plus tard.
    </div>
  </div>
    <kendo-dialog-actions>
      <button kendoButton
      (click)="getOption('sup')" 
      style="margin-right: 20px;">Supprimer</button>
      <button kendoButton
        [disabled]="!motifAbsentId && (checkAbsence || absenceAllSession)"
        (click)="getOption('abs')"
      >
        Valider
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
